import { createFileRoute } from "@tanstack/react-router";
import { canonicalLink, pathFromMatch, routeMeta } from "@/lib/seo";
import { cityHeadScripts } from "@/lib/cityJsonLd";
import { CityHomePage } from "@/components/CityHomePage";
import hero from "@/assets/original/hero-shade.jpg";

export const Route = createFileRoute("/sugar-land")({
  head: (ctx) => ({
    links: [canonicalLink(pathFromMatch(ctx))],
    meta: routeMeta(ctx, {
      title: "Custom Awnings, Covers & Shade in Sugar Land, TX | Texas Made Shade",
      description: "Custom welded awnings, sail shades, patio & pergola covers, marine canvas and aluminum fabrication for Sugar Land & Fort Bend County.",
      image: hero,
      socialTitle: "Custom Awnings & Shade — Sugar Land, TX",
      socialDescription: "Welded aluminum + Sunbrella canvas. Custom shade, covers and fabrication serving Sugar Land and Fort Bend County.",
      keywords: "awnings Sugar Land, awning company Sugar Land, custom awnings Sugar Land, sail shades Sugar Land, patio covers Sugar Land, pergola covers Sugar Land, metal awnings Sugar Land, canvas awnings Sugar Land, Texas Made Shade",
    }),
    scripts: cityHeadScripts("Sugar Land", "Fort Bend County"),
  }),
  component: () => <CityHomePage city="Sugar Land" region="Fort Bend County" />,
});
